require('./brokerOrdersAndMovementsCancelContractDefaultModal.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @commons
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const PrinterPreviewManagerButton = require('components/contactCenter/printer/printerPreviewManagerButton');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');

// @ constants
const { DATE_FORMAT_DAY_MONTH, DATE_FORMAT, BROKER_JOINT_CONTRACTS_CRYPTO } = require('constants/index');
const CLASS_NAME = 'broker-orders-and-movements-cancel-contract-default-modal';
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');


class BrokerOrdersAndMovementsCancelContractDefaultModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
        this.buildDetail = this.buildDetail.bind(this);
    }

    buildFormattedDate(date) {
        if (DateHelper.isToday(date)) {
            return (
                <span className="label-date">
                    <span className="label-date__text">
                        {LABEL_DATE_TODAY}
                    </span>
                </span>
            );
        }

        if (DateHelper.isYesterday(date)) {
            return (
                <span className="label-date">
                    <span className="label-date__text">
                        {LABEL_DATE_YESTERDAY}
                    </span>
                </span>
            );
        }

        if (DateHelper.isCurrentYear(date)) {
            return (
                <span className="label-date">
                    {DateHelper.formatDate(date, DATE_FORMAT_DAY_MONTH)}
                </span>
            );
        }

        return (
            <span className="label-date">
                {DateHelper.formatDate(date, DATE_FORMAT)}
            </span>
        );
    }

    buildDetailList() {
        const { immTransaction, showAsLarge } = this.props;
        const labelDate = this.buildFormattedDate(immTransaction.get('date'));
        let result;
        const isCrypto = immTransaction.get('movementType') === BROKER_JOINT_CONTRACTS_CRYPTO;
        const operationType = isCrypto
            ? formatText('broker-cryptoTransactionType.' + immTransaction.get('type').toLowerCase())
            : immTransaction.get('type', '')
        const detailState = isCrypto
            ? formatText('broker-cryptoTransactionState.' + immTransaction.get('state').toLowerCase())
            : immTransaction.get('state');

        if (showAsLarge) {
            result = (
                <ul className={`${CLASS_NAME}__list ${CLASS_NAME}__body`}>
                    <li><FormattedText value="broker-ordersAndMovementsCancelOperationModalOrderNumber" />: <b>{immTransaction.get('number', '')}</b></li>
                    <li><FormattedText value="broker-ordersAndMovementsCancelOperationModalValue" />: <b>{immTransaction.get('description', '')}</b></li>
                    <li><FormattedText value="broker-ordersAndMovementsCancelOperationModalOperationType" />: <b>{operationType}</b></li>
                    <li><FormattedText value="broker-ordersAndMovementsCancelOperationModalDateAndTime" />: <b>{labelDate}</b></li>
                    <li><FormattedText value="broker-ordersAndMovementsCancelOperationModalSituation" />: <b>{detailState}</b></li>
                </ul>
            );
        } else {
            result = (
                <ul className={`${CLASS_NAME}__list ${CLASS_NAME}__body`}>
                    <li>
                        <FormattedText value="broker-ordersAndMovementsCancelOperationModalOrderNumber" />:{' '}
                        <b>{immTransaction.get('id', '')}</b>
                    </li>
                    <li>
                        <FormattedText value="broker-ordersAndMovementsCancelOperationModalSituation" />:{' '}
                        <b>{immTransaction.get('stateLabel', '')}</b>
                    </li>
                </ul>
            );
        }

        return result;
    }

    buildDetail() {
        const { immOrderCancel } = this.props;
        const hasError = !!immOrderCancel.get('error');
        const errorMessage =
            hasError && formatText('broker-ordersAndMovementsCancelOperationErrorText');
        const detailList = this.buildDetailList();
        const titleValue = "broker-ordersAndMovementsCancelOperationModalPrintableTitle";

        return (
            <section id="printable-wizard" className={`${CLASS_NAME}__details`}>
                {detailList}
                <ContactCenterRender>
                    <PrinterPreviewManager titleOverrider={titleValue} />
                </ContactCenterRender>
                <div className={`${CLASS_NAME}__error`}>
                    {errorMessage}
                </div>
            </section>
        );
    }

    buildFooter() {
        const { immOrderCancel } = this.props;

        return (
            <section className={`${CLASS_NAME}__footer row`}>
                <div className="col-xs-6 text-right">
                    <ContactCenterRender>
                        <PrinterPreviewManagerButton
                            id="btn_brokerOrdersAndMovementsActivityFilter_apply"
                            onClick={this.handleFormSubmit}
                            loading={immOrderCancel.get('inProgress')}
                        >
                            <FormattedText value="broker-ordersAndMovementsCancelOperationModalApply" />
                        </PrinterPreviewManagerButton>
                    </ContactCenterRender>
                </div>
            </section>
        );
    }

    buildHeader() {
        return (
            <section className={`${CLASS_NAME}__header`}>
                <header className={`${CLASS_NAME}__title`}>
                    <FormattedText value="broker-ordersAndMovementsCancelOperationModalTitle" />
                </header>
                <div className={`${CLASS_NAME}__body`}>
                    <FormattedText value="broker-ordersAndMovementsCancelOperationModalBody" />
                </div>
            </section>
        );
    }


    handleFormSubmit() {
        const { immTransaction, requestCancelAnOrder, history } = this.props;
        requestCancelAnOrder(immTransaction, history);
    }

    render() {
        const header = this.buildHeader();
        const detail = this.buildDetail();
        const footer = this.buildFooter();

        return (
            <div className={`${CLASS_NAME}__container`}>
                <div className={`${CLASS_NAME}__form`}>
                    {header}
                    {detail}
                    {footer}
                </div>
            </div>
        );
    }
}

BrokerOrdersAndMovementsCancelContractDefaultModal.propTypes = {
    immTransaction: PropTypes.object.isRequired,
    immOrderCancel: PropTypes.object.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    requestCancelAnOrder: PropTypes.bool.isRequired,
    showAsLarge: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(BrokerOrdersAndMovementsCancelContractDefaultModal);
